import thumbnailsModalTpl from '../templates/thumbnails_modal.directive.html';

export default function ThumbnailModalController(
  $scope,
  $modal,
  $q,
  CreativeService,
  ImageService,
  MixpanelService
) {
  var vm = this;
  vm.getModalWidth = getModalWidth;
  vm.getModalHeight = getModalHeight;
  vm.setCroppedThumbnailUrl = setCroppedThumbnailUrl;
  vm.setThumbnailUrl = setThumbnailUrl;
  vm.changeImage = changeImage;
  vm.crop = crop;
  vm.errorMessage = null;
  vm.creativeService = CreativeService;

  var modalWidth = null;
  var modalHeight = null;

  function getModalWidth() {
    modalWidth =
      modalWidth || document.getElementById('thumbnail-modal').clientWidth;
    return modalWidth;
  }

  function getModalHeight() {
    modalHeight =
      modalHeight || document.getElementById('thumbnail-modal').clientHeight;
    return modalHeight;
  }

  function setCroppedThumbnailUrl(callback) {
    if (vm.loading) {
      return $q.resolve();
    }

    callback = callback || function() {};
    vm.errorMessage = null;

    if (vm.imageIsCropped) {
      MixpanelService.track('Image Cropped');
    }

    vm.loading = true;

    return ImageService.uploadDataUrl('/thumbnails', vm.rawCroppedImage)
      .then(uploadSuccess)
      .then(callback)
      .catch(uploadError)
      .finally(() => (vm.loading = false));
  }

  function uploadSuccess(response) {
    // this code also needs to run in ThumbnailsController
    // when gifs are uploaded because cropping is skipped in that case
    CreativeService.creative.thumbnailUrl = response.data.thumbnailUrl;
    if (
      $scope.slideIndex !== undefined &&
      response.data.thumbnailUrl !== undefined
    ) {
      $scope.callback($scope.slideIndex, response.data.thumbnailUrl);
    }
  }

  function uploadError() {
    vm.errorMessage = 'Something went wrong. Please try again.';
  }

  function setThumbnailUrl(callback) {
    callback = callback || function() {};
    CreativeService.creative.thumbnailUrl = vm.thumbnailUrl;
    callback();
  }

  function crop(url = CreativeService.creative.thumbnailUrl) {
    $scope.originalUrl = url;
    open();
  }

  function changeImage() {
    $scope.originalUrl = null;
    open();
  }

  function open() {
    $modal.open({
      animation: true,
      template: thumbnailsModalTpl,
      controller: ThumbnailModalInstanceController,
      controllerAs: 'modalInstanceVm',
      scope: $scope,
      size: 'lg'
    });
  }

  return vm;
}

ThumbnailModalController.$inject = [
  '$scope',
  '$modal',
  '$q',
  'CreativeService',
  'ImageService',
  'MixpanelService'
];

function ThumbnailModalInstanceController($scope, $modalInstance) {
  var vm = this;
  vm.cancel = cancel;

  function cancel() {
    $modalInstance.close(false);
  }

  return vm;
}

ThumbnailModalInstanceController.$inject = ['$scope', '$modalInstance'];
